import { Link } from "react-router-dom";

const PrintLink = ({ label = "", text = "" }) => {
  const handlePrintLabel = () => {
    // Create a new window for printing
    const printWindow = window.open("", "_blank");
    // Add the GIF image to the new window
    printWindow.document.write(`
      <html>
        <head>
          <title>Shipping Label</title>
        </head>
        <body>
          <img src="data:image/gif;base64,${label}" />
        </body>
      </html>
    `);
    printWindow.document.close();

    // Wait for the image to load, then print
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  return (
    <td className="w-full max-w-[100px]">
      <div className="flex items-center justify-center whitespace-nowrap text-center overflow-hidden bg-white font-ubuntuRegular shadow h-[36px] p-1 rounded">
        <span
          onClick={handlePrintLabel}
          className="cursor-pointer hover:underline hover:text-primary decoration-primary text-ellipsis"
        >
          {text}
        </span>
      </div>
    </td>
  );
};

export default PrintLink;
